import React from 'react';
import EngineScene from './EngineScene';
import menger from '../intro-engine/menger';

// gb4k.fr V2 Menger sponge — an infinite raymarched fractal flight.
const MengerVisualization: React.FC = () => <EngineScene make={menger} />;
export default MengerVisualization;
